import { render, staticRenderFns } from "./PecasFormDialogo.vue?vue&type=template&id=426180dd&scoped=true&"
import script from "./PecasFormDialogo.vue?vue&type=script&lang=js&"
export * from "./PecasFormDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426180dd",
  null
  
)

export default component.exports